/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Input, OnChanges} from '@angular/core';
import * as _ from 'lodash';
import {TargetingHelper} from '../targeting-helper';
import {ADN_TARGETING_TYPES} from '../targeting-constants';

import template from './keyword-summary.component.html';

@Component({
  standalone: false,
  selector: 'adn-targeting-keyword-summary',
  template
})
export class KeywordSummaryComponent implements OnChanges {
  @Input() targets: any;

  data: any[] = [];
  isComplex = false;
  restricted = false;
  showOnly = 2;
  quantity = 2;

  ngOnChanges(): void {
    const targets = this.targets || {};
    this.isComplex = TargetingHelper.isComplex(targets, ADN_TARGETING_TYPES.keyword.id);

    if (this.isComplex) {
      this.data = [];
      _.forEach(targets, (entryObj) => {
        const inputted: any[] = [];
        const notInputted: any[] = [];
        _.forEach(entryObj.keywords, (k) => {
          const isNot = _.startsWith(k.toUpperCase(), 'NOT ');
          inputted.push({k: isNot ? k.substr(4).split('|').join(', ') : k.split('|').join(', '), not: isNot});
        });
        _.forEach(entryObj.notKeywords, (k) => {
          const isNot = _.startsWith(k.toUpperCase(), 'NOT ');
          notInputted.push({k: isNot ? k.substr(4).split('|').join(', ') : k.split('|').join(', '), not: isNot});
        });
        this.data.push({keywords: inputted, notKeywords: notInputted});
      });
    } else {
      const modelData: {model: any; inputted?: any} = {model: targets};
      TargetingHelper.simpleInit(modelData, 'keywords');
      const displayData = _.cloneDeep(modelData.inputted);

      const value = displayData.value.split(', ');
      const valueAll = displayData.valueAll.split(', ');
      const valueNotAny = displayData.valueNotAny.split(', ');

      const maxEntries = 30;
      this.restricted = false;
      if ((value.length + valueAll.length + valueNotAny.length) > maxEntries) {
        const sliceNumberValue = Math.min(value.length, maxEntries);
        displayData.shortValue = value.slice(0, sliceNumberValue).join(', ');

        const sliceNumberValueAll = Math.max(Math.min(valueAll.length, maxEntries - sliceNumberValue), 0);
        displayData.shortValueAll = valueAll.slice(0, sliceNumberValueAll).join(', ');

        const sliceNumberValueNotAny = Math.max(Math.min(valueNotAny.length, maxEntries - (sliceNumberValueAll + sliceNumberValue)), 0);
        displayData.shortValueNotAny = valueNotAny.slice(0, sliceNumberValueNotAny).join(', ');

        this.restricted = true;
      }
      this.data = displayData;
    }
    this.quantity = this.showOnly;
  }

  switchUp(): void {
    if (this.quantity === this.showOnly) {
      this.quantity = this.data.length;
      return;
    }
    this.quantity = this.showOnly;
  }

  showAll(): void {
    this.restricted = false;
  }
}
